import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable';
import { useTranslation } from 'react-i18next';

const DataTable = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("Firm List")} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable;
